import React, { useMemo } from 'react';
import { useApp } from '@context/AppContext';
import { PageTitleBanner } from '@goodfynd/layout';
import { LoadingTruck } from '@goodfynd/ui';
import { useRequireAuth } from '@hooks/useRequireAuth';
import { useVendor } from 'context/VendorContext';

import Footer from '../Footer';
import Header from '../Header';
import { LoadingFullPage } from '../LoadingFullPage';

import type { LayoutWithHeaderProps } from './types';

import classes from './LayoutWithHeader.module.css';

export function LayoutWithVendorHeader({
  bannerContainerCss,
  children,
  allowedRoles,
  ...props
}: Omit<LayoutWithHeaderProps, 'authRequired'>): JSX.Element {
  const isLoggedIn = useRequireAuth({ allowedRoles });
  const { userIsLoading } = useApp();
  const { isLoading: vendorIsLoading, vendor } = useVendor();
  const isLoading = useMemo(
    () => userIsLoading || vendorIsLoading,
    [userIsLoading, vendorIsLoading]
  );

  if (!isLoggedIn) {
    return <></>;
  }

  return (
    <div className={classes['page-container']} style={{ paddingTop: 64 }}>
      <Header />
      <>
        {typeof props.bannerTitle === 'string' ? (
          <PageTitleBanner
            containerCss={bannerContainerCss}
            subtitle={vendor?.uniqueName ?? props.bannerSubTitle}
            title={props.bannerTitle}
          />
        ) : (
          props.bannerTitle
        )}

        {isLoading ? (
          <LoadingFullPage>
            <LoadingTruck />
          </LoadingFullPage>
        ) : (
          children
        )}
      </>
      <Footer />
    </div>
  );
}
